import { ColoursObj, Typography, getContrastYIQ } from "@eventr/common-storybook";
import { Box } from "@mui/material";
import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "state/bound.store";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { pushInTab } from "feat/nativeNavigation/NativeRootController";
import { isIosNativeNavigation } from "feat/nativeNavigation/platform";
import i18n from "i18n/i18next";
import { routes } from "routing";

export function OrganisationTag() {
  const { selectedOrg } = useBoundStore(
    useShallow((s) => {
      return {
        selectedOrg: s.selectedOrg,
      };
    }),
  );
  const { pushPath } = useGlobalRouter();

  if (!selectedOrg || !selectedOrg.friendlyName) return null;

  return (
    <Box sx={{
      display: "grid"
    }}>
      <Typography
        id="carouselslide-team-name"
        variant="bodySubtext"
        color={getContrastYIQ(ColoursObj.core.secondary)}
        onClick={async () => {
          // This header is portaled into home, chat, and team, each its own tab with
          // its own native stack under iOS native nav. A plain pushPath here would push
          // onto whichever tab the tap happened in instead of switching to Account, so
          // this explicitly switches tabs and pushes into Account's own stack.
          if (isIosNativeNavigation()) {
            await pushInTab("account", routes.account.organisations.path, i18n.t("account.swapTeam"));
          } else {
            pushPath(routes.account.organisations.path);
          }
        }}
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          background: ColoursObj.core.secondary,
        }}
      >
        {selectedOrg.friendlyName}
      </Typography>
    </Box>
  );
}
